import { render, staticRenderFns } from "./AAsignacionTablats.vue?vue&type=template&id=97c79dae"
import script from "./AAsignacionTablats.vue?vue&type=script&lang=js"
export * from "./AAsignacionTablats.vue?vue&type=script&lang=js"
import style0 from "./AAsignacionTablats.vue?vue&type=style&index=0&id=97c79dae&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports